import React from "react";
import "./LegendaUsers.css";


const LegendaUsers = () => {
  return (
    <div className="legenda-container">
      {/* Título da Seção */}
      <h4 className="legenda-title">Gênero dos Usuários</h4>

      {/* Lista Limpa */}
      <ul className="legenda-list">
        <li className="legenda-item">
          <div className="legenda-icon">
            <img src="/img/markers/masc_blue.png" alt="Masculino" />
          </div>
          <span className="legenda-text">Usuário masculino</span>
        </li>
        
        <li className="legenda-item">
          <div className="legenda-icon">
            <img src="/img/markers/fem_pink.png" alt="Feminino" />
          </div>
          <span className="legenda-text">Usuário feminino</span>
        </li>

         <li className="legenda-item">
          <div className="legenda-icon">
            <img src="/img/markers/others.png" alt="Outros" />
          </div>
          <span className="legenda-text">Outros</span>
        </li>

      </ul>
    </div>
  );
};

export default LegendaUsers;